import React from 'react';
import { useForm } from 'react-hook-form';
import { FormControl, Input, Textarea } from '../../../Components/Form';
import { Text } from '../../../globalStyles';
import { FormFields } from '../types';

type BeaconResourceFormProps = {
  register: ReturnType<typeof useForm<FormFields>>['register'];
};

export const BeaconResourceForm = ({ register }: BeaconResourceFormProps) => {
  return (
    <>
      <FormControl name="description" label="Additional Details">
        <Text.bodySmallGrey>Short description of offered resource</Text.bodySmallGrey>
        <Textarea
          name="description"
          ref={register}
          placeholder="Description of the resource and services offered"
        />
      </FormControl>
      <FormControl name="website" label="Link">
        <Input name="website" ref={register} placeholder="https://example.com/resource" />
      </FormControl>
    </>
  );
};
